var sizes = {
  jumbo: 80,
  'x-large': 56,
  large: 48,
  medium: 36,
  small: 28,
  'x-small': 20,
  tiny: 16,
  micro: 12
};
var borderRadiuses = {
  jumbo: 8,
  'x-large': 8,
  large: 8,
  medium: 8,
  small: 4,
  'x-small': 4,
  tiny: 4,
  micro: 4
};
var tokenToPixelSize = function tokenToPixelSize(token) {
  return sizes[token];
};
var tokenToBorderRadius = function tokenToBorderRadius(token) {
  return borderRadiuses[token];
};

export { borderRadiuses, sizes, tokenToBorderRadius, tokenToPixelSize };
